import { render, staticRenderFns } from "./TableManualForms.vue?vue&type=template&id=74fcab12&scoped=true"
import script from "./TableManualForms.vue?vue&type=script&lang=ts"
export * from "./TableManualForms.vue?vue&type=script&lang=ts"
import style0 from "./TableManualForms.vue?vue&type=style&index=0&id=74fcab12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fcab12",
  null
  
)

export default component.exports